import * as React from 'react';

import {Link} from 'shells/link/link';

import type {EmailStats as EmailStatsFragment} from 'nutshell-graphql-types';

import {EmailProgressBar} from './email-progress-bar';

import styles from './email-health-root.module.css';

type Props = {
    emailStats: EmailStatsFragment | null | undefined;
};

export function EmailStatusPopoverContent(props: Props) {
    if (!props.emailStats) return null;

    return (
        <div className={styles['email-health-popover']}>
            <div className={styles.body}>
                <div>
                    {`Sending more than ${props.emailStats.maxDailyEmailsCount} emails in a day might cause spam filters to flag your messages as junk. `}
                    <Link
                        newTab={true}
                        href='https://support.nutshell.com/en/articles/8428965-email-send-email-sending-limitations'
                        variant='primary'
                        size='small'
                    >
                        Learn why
                    </Link>
                </div>
                <EmailProgressBar stats={props.emailStats} />
            </div>
        </div>
    );
}
